import PropTypes from 'prop-types';
import {
  VendorsHeaderWrapper,
  VendorsHeaderFilterWrapper,
  VendorsHeaderFilterItemWrapper,
  VendorsHeaderFilterItem,
  VendorsHeaderCreateVendorButton,
} from './VendorsHeader.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const VendorsHeader = ({
  showCreateVendorBtn,
  stringsData,
  selectedStatusFilter,
  vendorsStatusFilterList,
  handleVendorStatusFilterClick,
  handelAddVendorBtnClick,
}) => (
  <VendorsHeaderWrapper>
    <VendorsHeaderFilterWrapper>
      {vendorsStatusFilterList &&
        vendorsStatusFilterList.map(vendorsFilterItem => {
          const isFilterSelected = vendorsFilterItem.key === selectedStatusFilter.key;

          return (
            <VendorsHeaderFilterItemWrapper
              key={vendorsFilterItem.key}
              selected={isFilterSelected}
              onClick={() => handleVendorStatusFilterClick(vendorsFilterItem)}
            >
              <VendorsHeaderFilterItem>{vendorsFilterItem.name}</VendorsHeaderFilterItem>
            </VendorsHeaderFilterItemWrapper>
          );
        })}
    </VendorsHeaderFilterWrapper>
    {showCreateVendorBtn && (
      <VendorsHeaderCreateVendorButton as="button" onClick={() => handelAddVendorBtnClick(true)}>
        {stringsData.vendorsHeader.createVendorButton}
      </VendorsHeaderCreateVendorButton>
    )}
  </VendorsHeaderWrapper>
);
VendorsHeader.propTypes = {
  showCreateVendorBtn: PropTypes.bool,
  stringsData: PropTypes.shape({
    vendorsHeader: PropTypes.shape({
      allVendorsFilterItem: PropTypes.string,
      createVendorButton: PropTypes.string,
    }),
  }).isRequired,
  selectedStatusFilter: PropTypes.shape({
    key: PropTypes.number,
  }),
  vendorsStatusFilterList: PropTypes.arrayOf(PropTypes.shape({})),
  handleVendorStatusFilterClick: PropTypes.func,
  handelAddVendorBtnClick: PropTypes.func,
};

VendorsHeader.defaultProps = {
  showCreateVendorBtn: true,
  selectedStatusFilter: {},
  vendorsStatusFilterList: [],
  handleVendorStatusFilterClick: () => {},
  handelAddVendorBtnClick: () => {},
};

export default VendorsHeader;
